import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { Alert, Button } from 'antd';
import { AuthContext } from '../../context/AuthContext';
import AccountDropdown from '../common/AccountDropdown';
import logger from '../../utils/logger';

const Header = () => {
  const { currentUser, stopImpersonation } = useContext(AuthContext);
  const location = useLocation();

  // Check if currently impersonating
  const isImpersonating = currentUser?.impersonating || false;
  const impersonatedTenantName = currentUser?.impersonated_tenant_name || '';

  // Function to get the current page title based on the path
  const getPageTitle = () => {
    const path = location.pathname;
    if (path.includes('/core-hypothesis')) return 'Core Hypothesis';
    if (path.includes('/question-evaluator')) return 'Question Evaluator';
    if (path.includes('/ai-coach')) return 'AI Coach';
    if (path.includes('/report-writer')) return 'Report Writer';
    if (path.includes('/archive')) return 'Archive';
    if (path.includes('/user-admin')) return 'User Management';
    if (path.includes('/user-management')) return 'User Management';
    if (path.includes('/tenant-management')) return 'Tenant Management';
    if (path.includes('/content-management')) return 'Content Management';
    // Default title if route doesn't match any of the above
    return 'Spark - Rapid Learning Cycles';
  };

  const handleStopImpersonation = async () => {
    try {
      await stopImpersonation();
      // Reload to refresh all components
      window.location.reload();
    } catch (error) {
      logger.error('Failed to stop impersonation:', error);
    }
  };

  return (
    <>
      {/* Impersonation Banner */}
      {isImpersonating && (
        <Alert
          message={
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span>
                <strong>⚠️ Impersonation Mode:</strong> You are currently viewing as <strong>{impersonatedTenantName}</strong>. All actions are performed in the context of this tenant.
              </span>
              <Button
                size="small"
                type="primary"
                danger
                onClick={handleStopImpersonation}
                style={{ marginLeft: 16 }}
              >
                Exit Impersonation
              </Button>
            </div>
          }
          type="warning"
          banner
          style={{
            position: 'sticky',
            top: 0,
            zIndex: 1000,
            margin: 0,
            borderRadius: 0,
          }}
        />
      )}

      <header className="app-header">
        <div className="header-left">
          <h1>{getPageTitle()}</h1>
        </div>

        {currentUser && (
          <div className="header-right" data-tour="account-menu">
            <AccountDropdown />
          </div>
        )}
      </header>
    </>
  );
};

export default Header;